import FloodDss from "../../views/FloodDSS/Index.vue";

export default {
	path: "/FloodStatus",
	name: "FloodDss",
	meta: {
		breadcrumb: "Flood Status"
	},
	component: FloodDss,
	props: { pageTransition: "none" }
};
